<template>
    <el-collapse v-model="activeCategory" :accordion="true" class="ai-material-list">
        <el-collapse-item v-for="item in data" :key="item.materialCategoryId" :name="item.materialCategoryId" :title="item.title">
            <el-tag 
            v-for="material in item.materials" 
            :key="material.materialId" 
            @click="$emit('select', material)" 
            :class="{'ai-material-tag': true, active: selections.includes(material.materialId), disabled: material.disabled}"
            type="info"
            effect="plain"
            >
            {{material.title}}
            </el-tag>
        </el-collapse-item>
    </el-collapse>
</template>
<script>
export default {
    name: 'ai-material-list',
    props: {
        data: {
            type: Array,
            default(){
                return []
            }
        },
        selections: {
            type: Array,
            default(){
                return []
            }
        }
    },
    data(){
        return {
            activeCategory: null
        }
    },
    watch: {
        activeCategory(value){
            console.log('active category:', value)
            this.$emit('change', value)
        }
    }
}
</script>
<style lang="scss">
.ai-material-list{
    &.el-collapse{
        border-color: #a8a8ac;
        .el-collapse-item{
            .el-collapse-item__header,.el-collapse-item__wrap{
                background: transparent;
                color: #ffffff;
                border-bottom-color: #a8a8ac;
            }
            .el-collapse-item__header{
                font-size: 18px;
                transition: all .3s;
                &.is-active{
                    border-bottom-color: transparent;
                }
            }
        }
    }
    .el-tag.el-tag--info.el-tag--plain{
        background: #444444;
        border-color: #c8c8c8;
        color: #ffffff;
        cursor: pointer;
        margin: 4px 5px;
        .disabled{
            color: #c8c8c8;
            cursor: default;
        }
    }
}
</style>